module.exports = global["jQuery"] = require("-!/home/xander/GitHub/FLAVIA/node_modules/source-map-loader/index.js!/home/xander/GitHub/FLAVIA/node_modules/source-map-loader/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/source-map-loader!./~/jquery/dist/jquery.js-exposed
// module id = 3
// module chunks = 0